export default{

    allVariables : state => {
        let variables = {
            api_decode : state.api_decode,
            api_authentication: state.api_authentication,
            host_authentication : state.host_authentication,
            firebase_config_game : state.firebase_config_game,
            firebase_config_chat : state.firebase_config_chat
        }

        return variables
    },
}